import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { HiXMark } from "react-icons/hi2";

import { Button } from "shared/components";
import { BFC } from "shared/types";

type Props = {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onCancelAndRestore: () => void;
  isLoading: boolean;
};

export const CancelOrderModal: BFC<Props> = ({
  open,
  onClose,
  onCancel,
  onCancelAndRestore,
  isLoading,
}) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog open={open} onClose={onClose} className="relative z-50">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="bg-black/40 fixed inset-0" />
        </Transition.Child>
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="h-max bg-white rounded-lg p-4 w-full max-w-md">
              <div className="flex items-center justify-between">
                <Dialog.Title className="font-bold text-lg">注文のキャンセル</Dialog.Title>
                <button
                  onClick={onClose}
                  className="p-1 rounded hover:bg-gray-100"
                  aria-label="閉じる"
                >
                  <HiXMark size={24} className="text-gray-500" />
                </button>
              </div>
              <Dialog.Description className="mt-4">
                注文をキャンセルしますか？
                <br />
                カートに戻すと、商品を再注文しやすくなります。
              </Dialog.Description>

              <div className="flex flex-col gap-3 mt-6">
                <Button
                  primary
                  block
                  onClick={onCancelAndRestore}
                  disabled={isLoading}
                >
                  注文をキャンセルしてカートに戻す
                </Button>
                <Button
                  block
                  onClick={onCancel}
                  disabled={isLoading}
                >
                  注文をキャンセルする
                </Button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};
